// src/data/comedians/kev-adams.js

const base = {
  id: 'kev-adams',
  slug: 'kev-adams',
  name: 'Kev Adams',
  birthYear: 1991,
  image: require('@/assets/images/img_Kev_Adams.jpeg'),
  famousWorks: [
    'The Young Man Show',
    'Voilà Voilà',
    'Soda',
    'Les Profs',
    'Maison de retraite',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'French',
    shortBio: 'Extremely popular comedian among younger audiences',
    bio: `Kev Adams is one of the most successful comedians of his generation in France. He rose to fame at a very young age with humor centered on school life, youth culture, and everyday situations, quickly building a massive and loyal fanbase among younger audiences.\n\nBorn in 1991 in Paris, Adams started performing stand-up as a teenager, gaining online traction before becoming a mainstream phenomenon. His accessible humor and relatable storytelling struck a chord with France's youth, making him one of the most recognizable faces in French entertainment.\n\nHighly active on social media, in movies, and on stage, he has built a massive online following. His accessible humor and modern image keep him consistently relevant, and his successful film career has expanded his reach beyond stand-up.`,
    style: 'Youth-oriented humor, high energy, self-deprecation, relatable situations',
    achievements: [
      'Massive popularity with younger audiences',
      'Major box-office success in French cinema',
      'Strong social media influence',
      'Successful transition from stand-up to film',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Français',
    shortBio: 'Comédien extrêmement populaire auprès des jeunes',
    bio: `Kev Adams est l'un des comédiens les plus populaires de sa génération en France. Il a accédé à la célébrité très jeune grâce à un humour centré sur la vie scolaire, la culture jeune et les situations quotidiennes, construisant rapidement une base de fans massive et fidèle parmi les jeunes audiences.\n\nNé en 1991 à Paris, Adams a commencé à faire du stand-up adolescent, gagnant de la notoriété en ligne avant de devenir un phénomène grand public. Son humour accessible et ses récits avec lesquels on peut s'identifier ont touché les jeunes français.\n\nTrès actif sur les réseaux sociaux, au cinéma et sur scène, il a bâti un immense suivi en ligne. Son humour accessible et son image moderne lui permettent de rester constamment pertinent.`,
    style: 'Humour orienté vers les jeunes, haute énergie, autodérision, situations du quotidien',
    achievements: [
      'Popularité massive auprès des jeunes audiences',
      'Grand succès au box-office français',
      'Forte influence sur les réseaux sociaux',
      'Transition réussie du stand-up au cinéma',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Francés',
    shortBio: 'Comediante extremadamente popular entre el público joven',
    bio: `Kev Adams es uno de los comediantes más exitosos de su generación en Francia. Se hizo famoso a una edad muy temprana con un humor centrado en la vida escolar, la cultura juvenil y las situaciones cotidianas, construyendo rápidamente una base de fans masiva y leal entre el público joven.\n\nNacido en 1991 en París, Adams comenzó a hacer stand-up siendo adolescente, ganando tracción online antes de convertirse en un fenómeno mainstream. Su humor accesible y su narración relatable conectó con la juventud francesa.\n\nMuy activo en las redes sociales, en el cine y sobre el escenario, ha construido un seguimiento online masivo. Su humor accesible y su imagen moderna lo mantienen consistentemente relevante.`,
    style: 'Humor orientado a jóvenes, alta energía, autodesprecio, situaciones cotidianas',
    achievements: [
      'Popularidad masiva entre el público joven',
      'Gran éxito de taquilla en el cine francés',
      'Fuerte influencia en redes sociales',
      'Exitosa transición del stand-up al cine',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'فرنسي',
    shortBio: 'كوميدي يحظى بشعبية هائلة في أوساط الشباب',
    bio: `كيف آدامز أحد أنجح كوميديي جيله في فرنسا. ذاع صيته في سن مبكرة جدًا بفكاهة تتمحور حول الحياة المدرسية والثقافة الشبابية والمواقف اليومية، بانيًا سريعًا قاعدة جماهيرية ضخمة ومخلصة في أوساط الجمهور الشاب.\n\nوُلد عام 1991 في باريس وبدأ أداء الستاند أب في مرحلة المراهقة، مكتسبًا شهرة رقمية قبل أن يصبح ظاهرة شعبية واسعة. فكاهته المتاحة وروايته القريبة من القلوب أوجدت صدىً كبيرًا لدى شباب فرنسا.\n\nنشطٌ جدًا على وسائل التواصل الاجتماعي وفي السينما وعلى خشبة المسرح، بنى جمهورًا رقميًا هائلًا. فكاهته المتاحة وصورته العصرية تُبقيانه دائمًا في دائرة الضوء.`,
    style: 'فكاهة موجّهة للشباب، طاقة عالية، استهزاء بالنفس، مواقف يومية',
    achievements: [
      'شعبية هائلة في أوساط الجمهور الشاب',
      'نجاح كبير في شباك التذاكر السينمائي الفرنسي',
      'تأثير قوي على وسائل التواصل الاجتماعي',
      'انتقال ناجح من الستاند أب إلى السينما',
    ],
  },
];
